export interface ArchivedRecordsScope {
	hiddenStatuses: readonly (boolean | string)[];
	statusField: string;
}

export interface ArchivedRecordsRequestScope extends ArchivedRecordsScope {
	visibleStatuses: readonly (boolean | string)[];
}

export interface ArchivedRecordsSwitch extends ArchivedRecordsScope {
	label?: string;
	onChange?: (shown: boolean) => void;
	shown?: boolean;
}

const modelRecord = (model: unknown): Record<string, unknown> =>
	model && typeof model === "object" ? (model as Record<string, unknown>) : {};

const hasStatusFilter = (model: unknown, field: string): boolean => modelRecord(model)[field] != null;

const scopeFilterModel = (model: unknown, shown: boolean, scope: ArchivedRecordsRequestScope): unknown => {
	if (shown || hasStatusFilter(model, scope.statusField)) return model;
	return {
		...modelRecord(model),
		[scope.statusField]: { filterType: "set", values: scope.visibleStatuses }
	};
};

const rowPasses = (row: unknown, model: unknown, shown: boolean, scope: ArchivedRecordsScope): boolean =>
	shown ||
	hasStatusFilter(model, scope.statusField) ||
	!scope.hiddenStatuses.includes(
		scope.statusField.split(".").reduce<unknown>((value, field) => modelRecord(value)[field], row) as boolean | string
	);

const archivedRecordsScope = { hasStatusFilter, rowPasses, scopeFilterModel };

export default archivedRecordsScope;
